import StyledLink from '../StyledLink'
import { ENVIRONMENTS } from '../routes'
import type { Props } from '../types'

interface Params {
  environmentId: number
}

const LinkToSpaceEnvironment = ({
  children,
  environmentId,
  isHyperlink
}: (Props & Params)) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + ENVIRONMENTS + '/' + environmentId + '/edit'}
  >
    {children}
  </StyledLink>

export default LinkToSpaceEnvironment
